<template>
  <div v-if="isShow" class="join_book">
    <!-- 弹框提示加入书架  只向VIP/SVIP提示 -->
    <van-overlay :show="isShow">
      <div class="alert_wrapper" @click.stop>
        <div class="block">
          <img
            src="https://img.yzcdn.cn/upload_files/2020/04/27/FiwjhpH1BMR9CLt0BmUUvvdiKAi_.png"
          />
          <div class="msg">
            <div class="msg_top">是否加入书架</div>
            <div class="msg_bottom">加入后就可在书架看到这本书啦</div>
            <div class="button" @click="joinBook">加入书架</div>
            <div class="no" @click="close">不了，谢谢</div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Overlay, Toast } from 'vant'
import { setCookie, format } from '@/static/js/zjs.js'
import { addCollect } from '@/api/collectBook'
export default {
  name: '',
  components: {
    [Overlay.name]: Overlay
  },
  props: ['workbook_id', 'isShow'],

  data() {
    return {
      todayStr: format('yyyy-MM-dd', new Date()) // 今天日期
    }
  },
  mounted() {

  },
  methods: {
    format,
    // 加入书架
    joinBook() {
      addCollect([{ bookId: this.workbook_id }]).then((res) => {
        if (res) {
          Toast({ duration: 1000, message: '成功加入书架' })
          setCookie('joined' + this.workbook_id + this.todayStr, '1', 1)
          this.close()
        }
      })
    },
    close() {
      setCookie('joined' + this.workbook_id + this.todayStr, '1', 1)
      //   this.isShow = false;
      this.$emit('update:isShow', false)
      this.$pop.next()
    }
  }
}
</script>

<style lang="scss">
.alert_wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  &.alert_vip {
    width: 100%;
    div {
      position: relative;
    }
    img {
      width: 290px;
    }
    a {
      width: 200px;
      height: 50px;
      position: absolute;
      bottom: 0.7rem;
      margin: 0 auto;
      display: inline-block;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .block {
    width: 7.49rem;
    height: 7.13rem;
    background: rgba(255, 255, 255, 1);
    border-radius: 0.4rem;
    position: relative;
    img {
      width: 4.49rem;
      position: absolute;
      top: -0.84rem;
      left: 50%;
      transform: translateX(-50%);
    }
    .msg {
      width: 100%;
      text-align: center;
      margin-top: 2.87rem;
      .msg_top {
        font-size: 0.48rem;
        font-weight: 400;
        color: #333333;
        margin-bottom: 0.27rem;
      }
      .msg_bottom {
        margin-bottom: 0.76rem;
        font-size: 0.37rem;
        font-weight: 400;
        color: #999999;
      }
      .button {
        width: 5.41rem;
        margin: 0 auto;
        height: 1.04rem;
        line-height: 1.04rem;
        background: linear-gradient(90deg, rgba(255, 139, 62, 1), rgba(239, 66, 70, 1));
        border-radius: 0.52rem;
        font-size: 0.35rem;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 0.33rem;
      }
      .no {
        font-size: 0.32rem;
        font-weight: 400;
        text-decoration: underline;
        color: rgba(178, 178, 178, 1);
      }
    }
  }
}
</style>
